<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} bảng giá quảng cáo
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <b-row>
          <b-col :class="'col-md-8'">
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <!-- <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button> -->
                <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="man_hinh"
            label="Màn hình"
            :sortable="mData.tableRules.allowSorting"
            width="180px"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >
                {{
                  scope.row.man_hinh === "TrangChu" ? 'Trang chủ'  :
                  scope.row.man_hinh === "GioiThieu" ? 'Giới thiệu'  :
                  scope.row.man_hinh === "DiemDen" ? 'Điểm đến'  :
                  scope.row.man_hinh === "ChiTietDiemDen" ? 'Chi tiết điểm đến'  :
                  scope.row.man_hinh === "Tour" ? 'Tour'  :
                  scope.row.man_hinh === "ChiTietTour" ? 'Chi tiết tour'  :
                  scope.row.man_hinh === "LuuTru" ? 'Lưu trú'  :
                  scope.row.man_hinh === "ChiTietLuuTru" ? 'Chi tiết lưu trú'  :
                  scope.row.man_hinh === "AmThuc" ? 'Ẩm thực'  :
                  scope.row.man_hinh === "ChiTietAmThuc" ? 'Chi tiết ẩm thực'  :
                  scope.row.man_hinh === "GiaiTri" ? 'Giải trí'  :
                  scope.row.man_hinh === "ChiTietGiaiTri" ? 'Chi tiết giải trí'  :
                  scope.row.man_hinh === "VeDienTu" ? 'Vé điện tử'  :
                  scope.row.man_hinh === "TinTuc" ? 'Tin tức'  :
                  scope.row.man_hinh === "ChiTietTinTuc" ? 'Chi tiết tin tức'  : ''
                }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="chinh_sach"
            label="Chính sách"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <span
                class="text-css"
                style="word-wrap: break-all;"
                v-html="scope.row.chinh_sach">
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ngon_ngu"
            label="Ngôn ngữ"
            :sortable="mData.tableRules.allowSorting"
            width="120px"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{scope.row.ngon_ngu == "vi" ? 'Tiếng Việt' : scope.row.ngon_ngu == "en" ? 'Tiếng Anh' : ''}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Vị trí 1" width="100px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ (scope.row.gia_tien.find(x => x.vi_tri == "Vị trí 1") || {}).gia_tien | toCurrency  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Vị trí 2" width="100px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ (scope.row.gia_tien.find(x => x.vi_tri == "Vị trí 2") || {}).gia_tien | toCurrency  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Vị trí 3" width="100px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ (scope.row.gia_tien.find(x => x.vi_tri == "Vị trí 3") || {}).gia_tien | toCurrency  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Vị trí 4" width="100px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ (scope.row.gia_tien.find(x => x.vi_tri == "Vị trí 4") || {}).gia_tien | toCurrency  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Vị trí 5" width="100px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ (scope.row.gia_tien.find(x => x.vi_tri == "Vị trí 5") || {}).gia_tien | toCurrency  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Vị trí 6" width="100px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ (scope.row.gia_tien.find(x => x.vi_tri == "Vị trí 6") || {}).gia_tien | toCurrency  }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hien_thi"
            label="Hiển thị"
            :sortable="mData.tableRules.allowSorting"
            width="110px"
          >
            <template slot-scope="scope">
              <div class="text-center">{{
                scope.row.hien_thi == true ? "Hiển thị" : "Không hiển thị"
              }}</div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import LienHeApi from '../../../moduleApi/LienHeApi';
import DichVuQuangCaoApi from '@/moduleApi/DichVuQuangCaoApi';
import MethodService from '../../../service/MethodService';
import BangGiaQuangCaoModel from '@/views/admin/BangGiaQuangCao/BangGiaQuangCaoModel';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        moduleName: "BangGiaQuangCao", //requied
        tableRules: MethodService.copyObject(BangGiaQuangCaoModel.tableRules),
        dataDefault: {
          trangThai: MethodService.copyObject(BangGiaQuangCaoModel.trangThai),
          listTrangThai: MethodService.copyObject(BangGiaQuangCaoModel.trangThai),
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
      }
    }
  },
  filters: {
    toCurrency: function (value) {
      if (!value) return '';
      return new Intl.NumberFormat('vi-VN').format(value);
    }
  },
  created() {
    this.getBangGiaQuangCaoList();
  },
  methods: {
    async getBangGiaQuangCaoList() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(() => {});
      }

      let res = await DichVuQuangCaoApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getBangGiaQuangCaoList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getBangGiaQuangCaoList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getBangGiaQuangCaoList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getBangGiaQuangCaoList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },
    //thêm trangThaiNew vào object
    fn_mergeTrangThai(row, status) {
      let object = MethodService.copyObject(row);
      object.trangThaiNew = status;
      return object;
    },
    async fn_changeTrangThai(command) {
      let data = {
        id: command.id,
        xu_ly: command.trangThaiNew
      };
      await LienHeApi.update(data);
      this.getBangGiaQuangCaoList();
    },
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => {});
      }
    },
    async fn_delete(id) {
      await DichVuQuangCaoApi.delete(id);
      this.getBangGiaQuangCaoList();
    }
  }
}
</script>

<style scope>
.text-css{
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.text-css p{
  margin: 0;
}
</style>
